import { api } from '@/scripts/api';

export const AppointmentRequestService = {
    async getAll(accountId, config) {
        return new Promise((resolve, reject) => {
            const service = `/ms/appointments/v1/appointmentRequest/account/${accountId}`;

            const axiosConfig = {
                url: service,
                params: {...api.getNodeDataParams(config) }
            };

            api.ajax(axiosConfig)
                .then(resolve)
                .catch(reject);
        });
    },

    async getCount(accountId, queryParams) {
        const service = `/ms/appointments/v1/appointmentRequest/account/${accountId}`;
        const response = await api.get(`${service}?${queryParams}`);
        
        return response.data.data.count;
    },

    async get(id) {
        return api.get(`/ms/appointments/v1/appointmentRequest/request/${id}`);
    },

    async createAppointment(accountId, appointmentRequest, paymentMethodId, password) {
        const body = {
            ...appointmentRequest,
            paymentMethodId,
            password,
        };

        return api.post(`/ms/appointments/v1/appointmentRequest/account/${accountId}`, body);
    },

    async getFinanceValues() {
        const service = `/ms/appointments/v1/appointmentRequest/financeValues`;
        return api.get(service);
    },

    async getContactLists(clientId, config = {}) {
        const filters = [`ClientId eq ${clientId}`];
        if(config?.ids?.length > 0) {
            const inCondition = config.ids.map((id) => `Id eq ${id}`).join(' or ');
            filters.push(`and (${inCondition})`);
        }

        if(config.name) {
            const encodedName = encodeURIComponent(config.name);
            filters.push(`and contains(Name, '${encodedName}')`);
        }

        const filter = `$filter=${filters.join(' ')}`;
        const queryParams = [filter].join('&');

        return api.get(`/service/ListDetails?${queryParams}`);
    },
}